import { testimonials } from "@/mocks/homeData";

export default function Testimonials() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            玩家真实评价
          </h2>
          <p className="mt-3 text-foreground-600 text-base">
            来自全球百万玩家的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm w-4 h-4 flex items-center justify-center ${
                      i < item.rating
                        ? "ri-star-fill text-primary-500"
                        : "ri-star-line text-foreground-300"
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.comment}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500">{item.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}